import {
  systemRoutes,
  labRoutes,
  oaRoutes,
  constantRoutes,
  purchaseRoutes,
  resetRouter,
  stockRoutes
} from '@/router'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route, isAdmin) {
  if (route.funcPerms) {
    // todo 系统管理员显示全部路由
    if (isAdmin && isAdmin === '1') {
      return true
    }
    return roles.some(role => {
      const flag = role ? role.indexOf(route.funcPerms) !== -1 : false
      return flag
    })
  } else {
    // 没有funcPerms的路由也显示
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles, isAdmin) {
  const res = []
  // console.info('routes -> ', routes)
  routes.forEach(route => {
    const tmp = {
      ...route
    }
    if (hasPermission(roles, tmp, isAdmin)) {
      // console.info('aaa', roles, tmp)
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles, isAdmin)
      }
      res.push(tmp)
    }
  })

  // console.info('res -> ', res)

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, obj) {
    return new Promise(resolve => {
      resetRouter()
      const roles = obj.role
      const systemType = obj.type
      const isAdmin = obj.isadmin
      console.log('权限处理》》》当前roles:', obj)
      let asyncRoutes = systemRoutes
      if (systemType === 'lab') {
        asyncRoutes = labRoutes
      } else if (systemType === 'oa') {
        asyncRoutes = oaRoutes
      } else if (systemType === 'purchase') {
        asyncRoutes = purchaseRoutes
      } else if (systemType === 'stock') {
        asyncRoutes = stockRoutes
      }

      const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles, isAdmin)
      commit('SET_ROUTES', accessedRoutes)
      resolve(asyncRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
